module.exports = __webpack_public_path__ + "6ce27dbe18ccb4531f6462032acaa1f0.pdf";